const data = {
  "2025": [
  {
    "name": "Арман Бекетов",
    "country": "Казахстан",
    "company": "Industrial Build Group",
    "achievements": "Арман реализует проекты в сфере промышленного строительства. Его вклад отмечен премией за развитие строительной отрасли."
  },
  {
    "name": "Ольга Миронова",
    "country": "Россия",
    "company": "Натуральные Продукты",
    "achievements": "Ольга развивает производство натуральных продуктов питания. Её компания получила награду за качество и безопасность продукции."
  },
    {
    "name": "Вадим Пренко",
    "country": "Украина",
    "company": "Fraud Prevention Technologies",
    "achievements": "Вадим специализируется на разработке технологий кибербезопасности и защиты цифровых финансовых операций. Он создал и коммерциализировал запатентованную антифрод-систему, внедренную в крупных финансовых учреждениях. Его профессиональные достижения отмечены международными отраслевыми наградами."
  },
  {
    "name": "Давид Мкртчян",
    "country": "Армения",
    "company": "Tech Automation Solutions",
    "achievements": "Давид разрабатывает инженерные решения для автоматизации предприятий. Его деятельность отмечена премией за технологические инновации."
  },
  {
    "name": "Светлана Ильина",
    "country": "Беларусь",
    "company": "Текстильный Альянс",
    "achievements": "Светлана управляет текстильным производством. Её достижения отмечены наградой за развитие легкой промышленности."
  },
  {
    "name": "Тимур Саидов",
    "country": "Узбекистан",
    "company": "Silk Route Logistics",
    "achievements": "Тимур развивает международные транспортные маршруты. Его работа получила признание в сфере логистики и внешней торговли."
  },
  {
    "name": "Марина Костенко",
    "country": "Украина",
    "company": "Фарма Инновации",
    "achievements": "Марина занимается развитием фармацевтического производства. Её профессиональные успехи отмечены отраслевой премией в сфере здравоохранения."
  },
  {
    "name": "Лейла Мамедова",
    "country": "Азербайджан",
    "company": "Caspian Trade House",
    "achievements": "Лейла развивает экспорт потребительских товаров. Её вклад в международную торговлю отмечен наградой за предпринимательские достижения."
  },
  {
    "name": "Игорь Демченко",
    "country": "Молдова",
    "company": "Винный Стандарт",
    "achievements": "Игорь развивает современное винодельческое производство. Его продукция была отмечена на международных отраслевых конкурсах."
  },
  {
    "name": "Камилла Юсупова",
    "country": "Таджикистан",
    "company": "Mountain Travel Network",
    "achievements": "Камилла занимается развитием туристических проектов. Её вклад в продвижение национального туризма отмечен профессиональной наградой."
  },
  {
    "name": "Сергей Лавров",
    "country": "Россия",
    "company": "Машиностроительные Системы",
    "achievements": "Сергей производит оборудование для перерабатывающей промышленности. Его разработки получили признание за высокий уровень инженерных решений."
  },
  {
    "name": "Алина Гасанова",
    "country": "Азербайджан",
    "company": "Caspian Digital Media",
    "achievements": "Алина развивает цифровые медийные проекты. Её деятельность отмечена премией за вклад в развитие современных коммуникаций."
  },
  {
    "name": "Бахтиёр Рахимов",
    "country": "Узбекистан",
    "company": "Инновационный Технопарк",
    "achievements": "Бахтиёр поддерживает инновационные стартапы и технологические проекты. Его работа получила награду за развитие инновационной экосистемы."
  }
],
    "2024": [
      {
        "name": "Александр Петров",
        "country": "Россия",
        "company": "ЭнергоТех Системы",
        "achievements": "Александр успешно разрабатывает инновационные технологии в энергетической сфере. Он получил национальную премию за предпринимательские достижения и активно внедряет свои разработки."
      },
      {
        "name": "Лейла Исмайлова",
        "country": "Азербайджан",
        "company": "Каспий Логистика",
        "achievements": "Лейла занимается логистическим бизнесом. Её вклад в развитие международной торговли был отмечен наградой 'Лучший предприниматель года'."
      },
      {
        "name": "Дмитрий Иванов",
        "country": "Беларусь",
        "company": "АгроМашТех",
        "achievements": "Дмитрий внедряет инновации в сельскохозяйственное машиностроение. Он получил премию 'Инноватор года'."
      },
      {
        "name": "Анара Садыкова",
        "country": "Казахстан",
        "company": "Экострой Групп",
        "achievements": "Анара занимается экологическим строительством. Её проекты удостоены награды за вклад в устойчивое строительство."
      },
      {
        "name": "Сергей Волков",
        "country": "Россия",
        "company": "Волков Фарма",
        "achievements": "Сергей разрабатывает инновационные лекарства, получившие международное признание. Его достижения отмечены наградой за инновации в медицине."
      },
      {
        "name": "Оксана Петренко",
        "country": "Украина",
        "company": "ИТ Солюшенс",
        "achievements": "Оксана управляет IT-компанией. Её вклад в развитие технологий был отмечен национальной премией."
      },
      {
        "name": "Тимур Ахмедов",
        "country": "Узбекистан",
        "company": "Шелковый Текстиль",
        "achievements": "Тимур занимается экспортом текстиля. Его успехи отмечены премией 'Экспортёр года'."
      },
      {
        "name": "Диана Мамедова",
        "country": "Азербайджан",
        "company": "Баку Рестораны",
        "achievements": "Диана развивает сеть ресторанов, популяризирующих национальную кухню. Её работа получила признание как культурного посла."
      },
            {
        "name": "Рано Хамракул",
        "country": "Казахстан",
        "company": "ИП “ЕРА”",
        "achievements": "Рано занимается реконструкцией жилых помещений и интерьерным дизайном. Её работа была отмечена премией «Женщина Предприниматель года»."
      },
      {
        "name": "Николай Смирнов",
        "country": "Россия",
        "company": "Смирнов Логистика",
        "achievements": "Николай улучшает транспортные сети. Он удостоен премии за достижения в области логистики."
      },
      {
        "name": "Алтын Бекболотова",
        "country": "Киргизия",
        "company": "Горная Вода",
        "achievements": "Алтын занимается продажей бутилированной воды. Её работа была отмечена премией 'Предприниматель года'."
      },
      {
        "name": "Игорь Кузнецов",
        "country": "Беларусь",
        "company": "ЭлектроТех Групп",
        "achievements": "Игорь производит бытовую электронику. Он получил награду за технологические инновации."
      },
      {
        "name": "Марина Иванова",
        "country": "Молдова",
        "company": "Вина Ивановой",
        "achievements": "Марина экспортирует вина. Её работа удостоена премии за высокое качество винной продукции."
      }
    ],
    "2023": [
      {
        "name": "Рустам Каримов",
        "country": "Таджикистан",
        "company": "Памир АгроФермы",
        "achievements": "Рустам развивает органическое сельское хозяйство. Его деятельность признана на национальном уровне."
      },
      {
        "name": "Елена Петрова",
        "country": "Россия",
        "company": "Модный Дом Петровой",
        "achievements": "Елена управляет модным брендом. Её работа получила премию 'Дизайнер года'."
      },
      {
        "name": "Максим Коваленко",
        "country": "Украина",
        "company": "Солнечная Энергия",
        "achievements": "Максим занимается возобновляемой энергетикой. Его проекты отмечены наградами за экологическое лидерство."
      },
      {
        "name": "Зара Алиева",
        "country": "Азербайджан",
        "company": "Каспий Косметикс",
        "achievements": "Зара экспортирует косметическую продукцию. Её работа получила награду 'Международная бизнес-леди года'."
      },
      {
        "name": "Павел Морозов",
        "country": "Беларусь",
        "company": "Софт Морозова",
        "achievements": "Павел разрабатывает корпоративное ПО. Его инновации отмечены наградой 'Программист года'."
      },
      {
        "name": "Айгуль Нурсултанова",
        "country": "Казахстан",
        "company": "ЗерноЭкспорт",
        "achievements": "Айгуль экспортирует зерно. Её вклад в экспортную деятельность удостоен премии 'Экспортёр года'."
      },
      {
        "name": "Вадим Соколов",
        "country": "Россия",
        "company": "Инфраструктура Соколова",
        "achievements": "Вадим занимается реализацией инфраструктурных проектов. Его работа отмечена наградой за инженерное мастерство."
      },
      {
        "name": "Тамара Григорян",
        "country": "Армения",
        "company": "КиберБезопасность",
        "achievements": "Тамара разрабатывает кибербезопасные решения. Она получила премию за технологические достижения."
      },
      {
        "name": "Алексей Романов",
        "country": "Россия",
        "company": "МедТех Инновации",
        "achievements": "Алексей разрабатывает инновационные медицинские устройства. Его достижения в сфере здравоохранения отмечены национальной премией."
      },
      {
        "name": "Наргиза Алимова",
        "country": "Узбекистан",
        "company": "Традиции Востока",
        "achievements": "Наргиза занимается экспортом традиционных ремесленных изделий. Её вклад в сохранение культурного наследия отмечен наградой."
      },
      {
        "name": "Виталий Кузьмин",
        "country": "Украина",
        "company": "АгроТех Украина",
        "achievements": "Виталий производит современное сельскохозяйственное оборудование. Он получил премию 'Аграрный новатор'."
      },
      {
        "name": "Диана Сорокина",
        "country": "Молдова",
        "company": "Сорокина Логистикс",
        "achievements": "Диана занимается международными грузоперевозками. Её успехи отмечены наградой за достижения в логистике."
      }
    ],
    "2022": [
      {
        "name": "Сергей Назаров",
        "country": "Беларусь",
        "company": "Зеленая Энергия",
        "achievements": "Сергей развивает проекты в области ветровой энергетики. Он получил премию 'Лидер в возобновляемой энергетике'."
      },
      {
        "name": "Айсулу Турсунова",
        "country": "Киргизия",
        "company": "Текстиль Айсулу",
        "achievements": "Айсулу экспортирует текстильные изделия. Её достижения отмечены национальной премией."
      },
      {
        "name": "Игорь Петров",
        "country": "Россия",
        "company": "РоботТех",
        "achievements": "Игорь разрабатывает промышленных роботов. Его проекты получили награду за инновации в промышленности."
      },
      {
        "name": "Лилит Манукян",
        "country": "Армения",
        "company": "Гурман Армении",
        "achievements": "Лилит экспортирует уникальные продукты питания. Её работа удостоена премии за кулинарное мастерство."
      },
      {
        "name": "Андрей Смирнов",
        "country": "Россия",
        "company": "Смирнов ФинТех",
        "achievements": "Андрей занимается финансовыми технологиями. Его достижения отмечены наградой за лидерство в финтехе."
      },
      {
        "name": "Гульнара Бектемирова",
        "country": "Казахстан",
        "company": "Астана Консалтинг",
        "achievements": "Гульнара предоставляет консультационные услуги. Её вклад в бизнес-консалтинг отмечен премией 'Консультант года'."
      },
      {
        "name": "Олег Попов",
        "country": "Украина",
        "company": "Медика Украина",
        "achievements": "Олег производит доступные медицинские препараты. Его проекты получили национальное признание."
      },
      {
        "name": "Сабина Алиева",
        "country": "Азербайджан",
        "company": "Образование Онлайн",
        "achievements": "Сабина разрабатывает образовательные онлайн-платформы. Она получила награду за инновации в сфере образования."
      },
      {
        "name": "Иван Кузнецов",
        "country": "Беларусь",
        "company": "Молочные Традиции",
        "achievements": "Иван занимается экспортом молочной продукции. Его достижения отмечены наградой за вклад в сельское хозяйство."
      },
      {
        "name": "Мария Петрова",
        "country": "Россия",
        "company": "Косметика Марии",
        "achievements": "Мария создала бренд натуральной косметики. Её работа получила премию за лучший стартап."
      },
      {
        "name": "Тимур Махмудов",
        "country": "Узбекистан",
        "company": "Шелковые Традиции",
        "achievements": "Тимур возродил производство шелка. Его вклад в сохранение культурного наследия отмечен премией."
      },
      {
        "name": "Ольга Иванова",
        "country": "Украина",
        "company": "БиоТех Украина",
        "achievements": "Ольга разрабатывает биотехнологические решения. Она получила премию 'Биотехнологический новатор'."
      }
    ],
    "2021": [
      {
        "name": "Сергей Колесников",
        "country": "Россия",
        "company": "ЭкоСтрой",
        "achievements": "Сергей занимается экологически чистым строительством. Его проекты удостоены премии за устойчивое строительство."
      },
      {
        "name": "Арман Саргсян",
        "country": "Армения",
        "company": "Облачные Решения",
        "achievements": "Арман разрабатывает облачные вычислительные решения. Он получил награду за достижения в IT-сфере."
      },
      {
        "name": "Наталья Смирнова",
        "country": "Беларусь",
        "company": "Смирнова Мода",
        "achievements": "Наталья экспортирует дизайнерскую одежду. Её работа отмечена премией 'Дизайнер года'."
      },
      {
        "name": "Рустам Уразов",
        "country": "Казахстан",
        "company": "Горное Оборудование",
        "achievements": "Рустам занимается производством оборудования для добычи полезных ископаемых. Он удостоен награды за достижения в промышленности."
      },
      {
        "name": "Елена Павлова",
        "country": "Молдова",
        "company": "Павлова Эдьюкейшн",
        "achievements": "Елена создает образовательные материалы. Её работа получила премию за продвижение образовательных технологий."
      },
      {
        "name": "Вадим Петренко",
        "country": "Украина",
        "company": "Агро Инновации",
        "achievements": "Вадим развивает технологии точного земледелия. Его проекты отмечены наградой за аграрные инновации."
      },
      {
        "name": "Зарина Каримова",
        "country": "Таджикистан",
        "company": "Ремесла Зарина",
        "achievements": "Зарина экспортирует традиционные ремесленные изделия. Её вклад в ремесленное искусство удостоен национальной премии."
      },
      {
        "name": "Николай Соколов",
        "country": "Россия",
        "company": "АэроТех",
        "achievements": "Николай занимается разработкой беспилотных технологий. Он удостоен премии за инновации в аэрокосмической сфере."
      },
      {
        "name": "Марина Волкова",
        "country": "Беларусь",
        "company": "Натуральные Препараты",
        "achievements": "Марина производит натуральные лечебные препараты. Её достижения отмечены наградой за развитие натуральной медицины."
      },
      {
        "name": "Тимур Хусанов",
        "country": "Киргизия",
        "company": "Хусанов Логистика",
        "achievements": "Тимур развивает логистические услуги. Он удостоен премии за вклад в логистику."
      },
      {
        "name": "Анастасия Орлова",
        "country": "Россия",
        "company": "Дизайн Орловой",
        "achievements": "Анастасия занимается дизайном интерьеров. Её работа была отмечена премией за выдающиеся дизайнерские проекты."
      },
      {
        "name": "Виталий Бондаренко",
        "country": "Украина",
        "company": "ЭкоТопливо",
        "achievements": "Виталий развивает технологии биотоплива. Его проекты получили признание в области возобновляемой энергетики."
      }
    ],
    "2020": [
      {
        "name": "Арпине Мелконян",
        "country": "Армения",
        "company": "Ювелирное Искусство",
        "achievements": "Арпине экспортирует уникальные ювелирные изделия. Она удостоена премии за достижения в ювелирном искусстве."
      },
      {
        "name": "Дмитрий Фёдоров",
        "country": "Россия",
        "company": "ПромТех",
        "achievements": "Дмитрий производит промышленное оборудование. Его работа отмечена наградой за лидерство в производственном секторе."
      },
      {
        "name": "Лейла Мурадова",
        "country": "Азербайджан",
        "company": "Мурадова Диджитал",
        "achievements": "Лейла разрабатывает цифровые маркетинговые стратегии. Её достижения отмечены наградой за цифровые инновации."
      },
      {
        "name": "Сергей Попов",
        "country": "Беларусь",
        "company": "ЭкоХимия",
        "achievements": "Сергей производит экологически чистую химическую продукцию. Его инновации получили признание."
      },
      {
        "name": "Ольга Смирнова",
        "country": "Россия",
        "company": "Смирнова Отели",
        "achievements": "Ольга управляет сетью отелей. Её работа получила премию за достижения в гостиничном бизнесе."
      },
      {
        "name": "Алия Кенжебаева",
        "country": "Казахстан",
        "company": "ЛингваСервис",
        "achievements": "Алия предоставляет услуги по изучению иностранных языков. Её вклад в образование отмечен премией."
      },
      {
        "name": "Андрей Кузнецов",
        "country": "Украина",
        "company": "ЭкоМатериалы",
        "achievements": "Андрей занимается производством экологически чистых строительных материалов. Его достижения отмечены наградой за инновации в строительстве."
      },
      {
        "name": "Нина Петрова",
        "country": "Молдова",
        "company": "Фрукты Молдовы",
        "achievements": "Нина экспортирует свежие фрукты. Её работа получила премию за успехи в экспорте."
      },
      {
        "name": "Алексей Иванов",
        "country": "Россия",
        "company": "Спутниковые Решения",
        "achievements": "Алексей занимается разработкой спутниковых технологий. Его достижения отмечены премией в области космических технологий."
      },
      {
        "name": "Мариам Григорян",
        "country": "Армения",
        "company": "Текстиль Армении",
        "achievements": "Мариам экспортирует традиционные армянские текстильные изделия. Её работа удостоена премии за культурное наследие."
      },
      {
        "name": "Игорь Сидоров",
        "country": "Беларусь",
        "company": "Искусственный Интеллект",
        "achievements": "Игорь разрабатывает системы искусственного интеллекта. Его проекты получили премию за лидерство в сфере ИИ."
      },
      {
        "name": "Светлана Новикова",
        "country": "Россия",
        "company": "ЛюксМода",
        "achievements": "Светлана управляет брендом люксовой моды. Её работа отмечена наградой за успехи в индустрии моды."
      }
    ],
    "2019": [
      {
        "name": "Тимур Расулов",
        "country": "Узбекистан",
        "company": "ЭкоМобили",
        "achievements": "Тимур занимается разработкой электромобилей. Его работа получила награду за инновации в автомобильной индустрии."
      },
      {
        "name": "Оксана Коваль",
        "country": "Украина",
        "company": "Медиа Продакшн",
        "achievements": "Оксана развивает услуги в сфере медиа. Её вклад в медиа был отмечен национальной премией."
      },
      {
        "name": "Сергей Михайлов",
        "country": "Россия",
        "company": "МеталлТех",
        "achievements": "Сергей производит специализированные металлы. Его достижения отмечены наградой за инновации в металлургии."
      },
      {
        "name": "Аида Сапарова",
        "country": "Казахстан",
        "company": "Красота Сапаровой",
        "achievements": "Аида экспортирует косметическую продукцию. Её достижения были удостоены награды."
      },
      {
        "name": "Павел Лебедев",
        "country": "Беларусь",
        "company": "ГидроТех",
        "achievements": "Павел развивает гидроэнергетические проекты. Его работа отмечена премией за достижения в энергетике."
      },
      {
        "name": "Елена Васильева",
        "country": "Россия",
        "company": "Юридические Решения",
        "achievements": "Елена предоставляет юридические услуги. Её вклад в юриспруденцию был удостоен премии 'Лучший юрист года'."
      },
      {
        "name": "Арсен Меликов",
        "country": "Армения",
        "company": "ИнфраСтрой",
        "achievements": "Арсен занимается инфраструктурными проектами. Его вклад в строительство отмечен премией за выдающиеся достижения."
      },
      {
        "name": "Наталья Фёдорова",
        "country": "Украина",
        "company": "Архитектура Будущего",
        "achievements": "Наталья разрабатывает архитектурные проекты. Её работа получила награду за инновации в архитектуре."
      },
      {
        "name": "Дмитрий Орлов",
        "country": "Россия",
        "company": "РобоТех",
        "achievements": "Дмитрий занимается разработкой роботов с ИИ. Его достижения отмечены наградой за лидерство в робототехнике."
      },
      {
        "name": "Зарина Назарова",
        "country": "Узбекистан",
        "company": "Текстиль Назаровой",
        "achievements": "Зарина экспортирует хлопковые изделия. Её вклад в текстильную индустрию отмечен национальной премией."
      },
      {
        "name": "Игорь Петров",
        "country": "Беларусь",
        "company": "АгроБиоТех",
        "achievements": "Игорь развивает агробиотехнологии. Его работа получила награду за инновации в сельском хозяйстве."
      },
      {
        "name": "Ольга Смирнова",
        "country": "Россия",
        "company": "ЭкоПродукты",
        "achievements": "Ольга производит органические продукты питания. Её достижения отмечены премией за вклад в индустрию органических продуктов."
      }
    ],
    "2018": [
      {
        "name": "Андрей Ковальчук",
        "country": "Украина",
        "company": "Транспортные Решения",
        "achievements": "Андрей предоставляет транспортные услуги. Его вклад в логистику удостоен награды за инновации."
      },
      {
        "name": "Марина Петрова",
        "country": "Россия",
        "company": "Натуральное Здоровье",
        "achievements": "Марина разрабатывает натуральные лечебные средства. Её работа отмечена премией за достижения в области здоровья."
      },
      {
        "name": "Сергей Новиков",
        "country": "Беларусь",
        "company": "Инженерные Технологии",
        "achievements": "Сергей предоставляет инженерные услуги. Его вклад в инженерное дело отмечен наградой за выдающиеся достижения."
      },
      {
        "name": "Айгуль Бекжанова",
        "country": "Казахстан",
        "company": "IT Решения",
        "achievements": "Айгуль разрабатывает IT-решения. Её достижения в сфере технологий отмечены премией за инновации."
      },
      {
        "name": "Олег Иванов",
        "country": "Россия",
        "company": "Современное Сельское Хозяйство",
        "achievements": "Олег развивает современные методы ведения сельского хозяйства. Его работа отмечена наградой за достижения в агросфере."
      },
      {
        "name": "Лилит Петросян",
        "country": "Армения",
        "company": "Армянские Вина",
        "achievements": "Лилит экспортирует армянские вина. Её достижения удостоены премии за вклад в винодельческую индустрию."
      },
      {
        "name": "Алексей Смирнов",
        "country": "Украина",
        "company": "МобайлТех",
        "achievements": "Алексей разрабатывает мобильные приложения. Его работа отмечена наградой за инновации в IT."
      },
      {
        "name": "Светлана Иванова",
        "country": "Россия",
        "company": "Текстильные Традиции",
        "achievements": "Светлана экспортирует текстильные изделия. Её вклад в индустрию текстиля отмечен премией."
      },
      {
        "name": "Дмитрий Кузнецов",
        "country": "Беларусь",
        "company": "ХимТех",
        "achievements": "Дмитрий занимается производством химических продуктов. Его достижения в химической промышленности удостоены награды."
      },
      {
        "name": "Елена Михайлова",
        "country": "Россия",
        "company": "МедиаКоннект",
        "achievements": "Елена предоставляет PR-услуги. Её вклад в медиа отмечен премией за выдающиеся достижения в сфере коммуникаций."
      },
      {
        "name": "Тимур Султанов",
        "country": "Узбекистан",
        "company": "Фрукты Узбекистана",
        "achievements": "Тимур экспортирует фрукты. Его достижения в сельском хозяйстве отмечены премией за успехи в экспорте."
      },
      {
        "name": "Ольга Петрова",
        "country": "Украина",
        "company": "Модный Дом Петровой",
        "achievements": "Ольга развивает модный бренд. Её вклад в индустрию моды удостоен награды 'Молодой дизайнер года'."
      }
    ],
    "2017": [
      {
        "name": "Юлия Байбабина",
        "country": "Казахстан",
        "company": "Naomi Home Textile",
        "achievements": "Юлия создала бренд домашнего текстиля высокого качества. Её достижения отмечены Национальной Премией Президента Казахстана 'Золотое качество' и Международной Премией Предприниматель года СНГ."
      },
      {
        "name": "Сергей Соколов",
        "country": "Россия",
        "company": "ЭнергоЭффективность",
        "achievements": "Сергей разрабатывает решения для энергоэффективности. Его достижения в энергетике отмечены премией за инновации."
      },
      {
        "name": "Мария Иванова",
        "country": "Беларусь",
        "company": "Косметика Ивановой",
        "achievements": "Мария экспортирует косметическую продукцию. Её работа удостоена премии за успехи в индустрии красоты."
      },
      {
        "name": "Арман Григорян",
        "country": "Армения",
        "company": "Григорян IT",
        "achievements": "Арман разрабатывает программное обеспечение. Его достижения отмечены наградой за вклад в сферу IT."
      },
      {
        "name": "Алина Сидорова",
        "country": "Украина",
        "company": "Сидорова Логистика",
        "achievements": "Алина предоставляет услуги в сфере грузоперевозок. Её достижения в логистике удостоены премии за лидерство."
      },
      {
        "name": "Дмитрий Петров",
        "country": "Россия",
        "company": "Космические Технологии",
        "achievements": "Дмитрий занимается разработкой компонентов для аэрокосмической отрасли. Его достижения отмечены премией за инновации в космических технологиях."
      }
    ]
  }


  export default data;